import React from 'react';
import {View} from 'react-native';

import Text from '/component/base/Text';
import {DownlineProfile} from '/constant/TestIDs';
import {useTranslation} from '/provider/TranslationProvider';
import {generateComponentCallback} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';
import testProperties from '/util/testing/testProperties';

import {styles} from './LastChangeDateComponent.style';

interface LastChangeDateComponentProps {
  notes: string | null;
  notesUpdatedTs: string | null;
}

const LastChangeDateComponent: React.FC<LastChangeDateComponentProps> = ({
  notes = null,
  notesUpdatedTs = null,
}) => {
  const {tt} = useTranslation('CandidateEditNotes');
  const dateUtil = getDateUtilDefaultInstance();
  const formattedDate = notesUpdatedTs
    ? dateUtil.formatDate(notesUpdatedTs, 'MMMM d, yyyy')
    : '';

  return (
    <View>
      {notes && formattedDate && (
        <Text
          style={styles.dateText}
          {...testProperties(DownlineProfile.candidateNotesLastChange)}>
          {tt(
            'last.notes.change.relative',
            generateComponentCallback({
              component: <>Last change made {formattedDate}</>,
            }),
          )}
        </Text>
      )}
    </View>
  );
};

export default LastChangeDateComponent;
